import React, { useState, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import fetchBase from "../utils/fetchBase";
import "../pages/OuraSecondNav.css";


const OuraSecondNav = ({
    mode, // "members" or "actions"
    selectedCount = 0,
    allSelected = false,
    onSelectAll = () => {},
    onAssign = () => {},
    onMakeDynamic = () => {},
    onDynamicAssignmentClick = () => {},
    members = { employees: [], clients: [] },
    onMemberClick = () => {},
    onMemberDelete = () => {},
}) => {

    const [membersOpen, setMembersOpen] = useState(false);

    const [dynamicAssignments, setDynamicAssignments] = useState([]);
    const [expandedTopics, setExpandedTopics] = useState([]);

        useEffect(() => {
            if (!membersOpen) return;
            const authHeader = "Bearer " + localStorage.getItem("jwt_token");
            fetch(`${fetchBase}/api/document-hub/dynamic-assignments`, {
                headers: { Authorization: authHeader }
            })
                .then(res => res.json())
                .then(data => { if (Array.isArray(data)) setDynamicAssignments(data); })
                .catch(err => console.error("Failed to fetch dynamic assignments:", err));
        }, [membersOpen]);
    const [actionsOpen, setActionsOpen] = useState(false);
    const [assignPanelOpen, setAssignPanelOpen] = useState(false);
    const actionsMenuRef = useRef(null);
    const [allEmployees, setAllEmployees] = useState([]);
    const [allClients, setAllClients] = useState([]);
    const [pickerLoading, setPickerLoading] = useState(false);
    const [selectedTargets, setSelectedTargets] = useState([]); // [{targetType, targetId}]
    const [panelMode, setPanelMode] = useState("assign"); // "assign" or "dynamic"
    const [dynamicConfigOpen, setDynamicConfigOpen] = useState(false);
    const [dynamicTitle, setDynamicTitle] = useState("");
    const [dynamicFrequency, setDynamicFrequency] = useState("ONCE");
    const [dynamicStartDate, setDynamicStartDate] = useState("");
    const [dynamicInstructions, setDynamicInstructions] = useState("");
    const [dynamicDeadline, setDynamicDeadline] = useState("");
    const [dynamicCompletionBehavior, setDynamicCompletionBehavior] = useState("ENDS");

        const [visible, setVisible] = useState(false);

            useEffect(() => {
                const frame1 = requestAnimationFrame(() => {
                    const frame2 = requestAnimationFrame(() => setVisible(true));
                    return () => cancelAnimationFrame(frame2);
                });
                return () => cancelAnimationFrame(frame1);
            }, []);

        const token = localStorage.getItem("jwt_token");
        const authHeader = `Bearer ${token}`;

        const openAssignPanel = async () => {
            setAssignPanelOpen(true);
            setPickerLoading(true);
            try {
                const [empRes, clientRes] = await Promise.all([
                    fetch(`${fetchBase}/api/admin/by-admin`, { headers: { Authorization: authHeader } }),
                    fetch(`${fetchBase}/api/client/by-admin`, { headers: { Authorization: authHeader } })
                ]);
                const empData = await empRes.json();
                const clientData = await clientRes.json();
                setAllEmployees(Array.isArray(empData) ? empData : []);
                setAllClients(Array.isArray(clientData) ? clientData : []);
            } catch (err) {
                console.error("Failed to load employees/clients for assign panel:", err);
            } finally {
                setPickerLoading(false);
            }
        };

            const isTargetSelected = (targetType, targetId) =>
                selectedTargets.some(t => t.targetType === targetType && t.targetId === targetId);

            const toggleTarget = (targetType, targetId) => {
                setSelectedTargets(prev =>
                    isTargetSelected(targetType, targetId)
                        ? prev.filter(t => !(t.targetType === targetType && t.targetId === targetId))
                        : [...prev, { targetType, targetId }]
                );
            };

            const isSectionFullySelected = (targetType, list) =>
                list.length > 0 && list.every(item => isTargetSelected(targetType, item.id));

            const toggleSection = (targetType, list, checked) => {
                setSelectedTargets(prev => {
                    const withoutSection = prev.filter(t => t.targetType !== targetType);
                    if (!checked) return withoutSection;
                    const sectionTargets = list.map(item => ({ targetType, targetId: item.id }));
                    return [...withoutSection, ...sectionTargets];
                });
            };


            const handleConfirmAssign = () => {
                const targetsWithNames = selectedTargets.map(t => {
                    const list = t.targetType === "CLIENT" ? allClients : allEmployees;
                    const match = list.find(item => item.id === t.targetId);
                    const name = match ? `${match.firstName} ${match.lastName}` : null;
                    return { ...t, name };
                });
                onAssign(targetsWithNames);
                    setSelectedTargets([]);
                    setAssignPanelOpen(false);
                    setActionsOpen(false);
                };

                const handleConfirmDynamic = () => {
                    const targetsWithNames = selectedTargets.map(t => {
                        const match = allEmployees.find(item => item.id === t.targetId);
                        const name = match ? `${match.firstName} ${match.lastName}` : null;
                        return { ...t, name };
                    });
                    onMakeDynamic(targetsWithNames, {
                        assignmentTitle: dynamicTitle.trim(),
                        frequency: dynamicFrequency,
                        startDate: dynamicStartDate,
                        deadlineDate: dynamicFrequency === "ONCE" ? dynamicDeadline : null,
                        completionBehavior: dynamicCompletionBehavior,
                        instructions: dynamicInstructions
                    });
                    setSelectedTargets([]);
                    setDynamicConfigOpen(false);
                    setActionsOpen(false);
                    setDynamicTitle("");
                    setDynamicInstructions("");
                    setDynamicStartDate("");
                    setDynamicFrequency("ONCE");
                };


                useEffect(() => {
                    if (!actionsOpen) return;

                    const handleOutsideClick = (event) => {
                        if (actionsMenuRef.current && !actionsMenuRef.current.contains(event.target)) {
                            setActionsOpen(false);
                            setAssignPanelOpen(false);
                        }
                    };

                    document.addEventListener("mousedown", handleOutsideClick);
                    return () => document.removeEventListener("mousedown", handleOutsideClick);
                }, [actionsOpen]);

                return (


        <nav className={`oura-second-nav ${visible ? "nav-visible" : "nav-hidden"}`}>

            <div className="second-nav-left">
                {mode === "actions" && (
                    <label className="select-all-control">
                        <input
                            type="checkbox"
                            checked={allSelected}
                            onChange={(e) => onSelectAll(e.target.checked)}
                        />
                        <span>Select All</span>
                    </label>
                )}
            </div>

            <div className="second-nav-right">
                {mode === "members" && (
                    <div className="members-control-container">
                        <span
                            className="members-link"
                            onClick={() => setMembersOpen((prev) => !prev)}
                        >
                            Members
                        </span>

                        {createPortal(
                            <>
                                <div className={`members-panel ${membersOpen ? "open" : ""}`}>
                                    <div className="members-panel-header">
                                        <span>Members</span>
                                        <button
                                            className="members-panel-close"
                                            onClick={() => setMembersOpen(false)}
                                        >
                                            ✕
                                        </button>
                                    </div>
                                        <div className="members-panel-section">
                                            <h4>Clients</h4>
                                            {members.clients.length === 0 ? (
                                                <p className="members-empty">No clients assigned yet.</p>
                                            ) : (
                                                members.clients.map((c) => (
                                                    <div key={c.virtualHubId} className="member-row">
                                                        <span
                                                            className="member-row-name"
                                                            onClick={() => onMemberClick(c.virtualHubId)}
                                                        >
                                                            {c.name}
                                                        </span>
                                                        <button
                                                            className="member-row-delete"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                onMemberDelete(c.virtualHubId, c.name);
                                                            }}
                                                        >
                                                            🗑
                                                        </button>
                                                    </div>
                                                ))
                                            )}
                                        </div>
                                        <div className="members-panel-section">
                                            <h4>Employees</h4>
                                            {members.employees.length === 0 ? (
                                                <p className="members-empty">No employees assigned yet.</p>
                                            ) : (
                                                members.employees.map((e) => (
                                                    <div key={e.virtualHubId} className="member-row">
                                                        <span
                                                            className="member-row-name"
                                                            onClick={() => onMemberClick(e.virtualHubId)}
                                                        >
                                                            {e.name}
                                                        </span>
                                                        <button
                                                            className="member-row-delete"
                                                            onClick={(ev) => {
                                                                ev.stopPropagation();
                                                                onMemberDelete(e.virtualHubId, e.name);
                                                            }}
                                                        >
                                                            🗑
                                                        </button>
                                                    </div>
                                                ))
                                                    )}
                                                </div>

                                                {dynamicAssignments.length > 0 && (
                                                    <>
                                                        <hr style={{ border: "none", borderTop: "1px solid rgba(0,0,0,0.08)", margin: "14px 0 10px" }} />
                                                        <div className="members-panel-section">
                                                            <h4>Dynamic Assignments</h4>
                                                            {Object.entries(
                                                                dynamicAssignments.reduce((groups, da) => {
                                                                    const key = da.assignmentTitle;
                                                                    if (!groups[key]) groups[key] = [];
                                                                    groups[key].push(da);
                                                                    return groups;
                                                                }, {})
                                                            ).map(([title, assignments]) => {
                                                                const completedCount = assignments.filter(a => a.status === "COMPLETED").length;
                                                                const totalCount = assignments.length;
                                                                const isExpanded = expandedTopics.includes(title);
                                                                const dateStr = new Date(assignments[0].dateMadeDynamic).toLocaleDateString();

                                                                return (
                                                                    <React.Fragment key={title}>
                                                                        <div
                                                                            className="member-row"
                                                                            onClick={() =>
                                                                                setExpandedTopics(prev =>
                                                                                    prev.includes(title)
                                                                                        ? prev.filter(t => t !== title)
                                                                                        : [...prev, title]
                                                                                )
                                                                            }
                                                                            style={{ cursor: "pointer" }}
                                                                        >
                                                                            <span className="member-row-name">
                                                                                {title} — {dateStr}
                                                                            </span>
                                                                            <span style={{ fontSize: "12px", color: "#6e6e73", flexShrink: 0 }}>
                                                                                {completedCount} of {totalCount} Completed
                                                                            </span>
                                                                        </div>

                                                                        {isExpanded && assignments.map((da) => (
                                                                            <div key={da.id} className="member-row" style={{ paddingLeft: "16px" }}>
                                                                                <span
                                                                                    className="member-row-name"
                                                                                    style={{ fontSize: "12px" }}
                                                                                    onClick={() => onDynamicAssignmentClick(da)}
                                                                                >
                                                                                    {da.employeeName}
                                                                                </span>
                                                                                <span style={{
                                                                                    width: "8px", height: "8px", borderRadius: "50%",
                                                                                    background: da.status === "COMPLETED" ? "#34c759" : "#ff9500",
                                                                                    display: "inline-block", flexShrink: 0
                                                                                }} />
                                                                            </div>
                                                                        ))}
                                                                    </React.Fragment>
                                                                );
                                                            })}
                                                        </div>
                                                    </>
                                                )}

                                        </div>
                                        {membersOpen && (
                                    <div
                                        className="members-panel-backdrop"
                                        onClick={() => setMembersOpen(false)}
                                    />
                                )}
                            </>,
                            document.body
                        )}
                    </div>
                )}


                        {mode === "actions" && (
                            <div className="actions-menu-container" ref={actionsMenuRef}>

                            <button
                                className="three-dot-trigger"
                                disabled={selectedCount === 0}
                                onClick={() => setActionsOpen((prev) => !prev)}
                            >
                                •••
                            </button>
                            {actionsOpen && selectedCount > 0 && (
                                <div className="actions-dropdown">
                                    {!assignPanelOpen ? (
                                        <>
                                            <button onClick={() => { setPanelMode("assign"); openAssignPanel(); }}>
                                                Assign
                                            </button>
                                            <button onClick={() => { setPanelMode("dynamic"); openAssignPanel(); }}>
                                                Make Dynamic
                                            </button>
                                        </>
                                    ) : (
                                        <div className="assign-panel">
                                            <div className="assign-panel-header">
                                                <span>Assign to</span>
                                                <button
                                                    className="assign-panel-back"
                                                    onClick={() => setAssignPanelOpen(false)}
                                                >
                                                    Back
                                                </button>
                                            </div>
                                                {pickerLoading ? (
                                                    <p className="assign-panel-loading">Loading...</p>
                                                ) : (
                                                    <div className="assign-panel-list">
                                                        {panelMode === "assign" && (
                                                            <>
                                                                <div className="assign-section-header">
                                                                    <label className="assign-section-select-all">
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={isSectionFullySelected("CLIENT", allClients)}
                                                                            onChange={(e) => toggleSection("CLIENT", allClients, e.target.checked)}
                                                                        />
                                                                        <h5>Clients</h5>
                                                                    </label>
                                                                </div>
                                                                {allClients.length === 0 ? (
                                                                    <p className="members-empty">No clients found.</p>
                                                                ) : (
                                                                    allClients.map((c) => (
                                                                        <label key={`CLIENT-${c.id}`} className="assign-target-row">
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={isTargetSelected("CLIENT", c.id)}
                                                                                onChange={() => toggleTarget("CLIENT", c.id)}
                                                                            />
                                                                            <span>{c.firstName} {c.lastName}</span>
                                                                        </label>
                                                                    ))
                                                                )}
                                                            </>
                                                        )}
                                                        <div className="assign-section-header">
                                                            <label className="assign-section-select-all">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={isSectionFullySelected("EMPLOYEE", allEmployees)}
                                                                    onChange={(e) => toggleSection("EMPLOYEE", allEmployees, e.target.checked)}
                                                                />
                                                                <h5>Employees</h5>
                                                            </label>
                                                        </div>
                                                        {allEmployees.length === 0 ? (
                                                            <p className="members-empty">No employees found.</p>
                                                        ) : (
                                                            allEmployees.map((e) => (
                                                                <label key={`EMPLOYEE-${e.id}`} className="assign-target-row">
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={isTargetSelected("EMPLOYEE", e.id)}
                                                                        onChange={() => toggleTarget("EMPLOYEE", e.id)}
                                                                    />
                                                                    <span>{e.firstName} {e.lastName}</span>
                                                                </label>
                                                            ))
                                                        )}
                                                    </div>
                                                )}

                                            <button
                                                className="assign-confirm-button"
                                                disabled={selectedTargets.length === 0}
                                                onClick={() => {
                                                    if (panelMode === "dynamic") {
                                                        setDynamicConfigOpen(true);
                                                        setAssignPanelOpen(false);
                                                        setActionsOpen(false);
                                                    } else {
                                                        handleConfirmAssign();
                                                    }
                                                }}
                                            >
                                                {panelMode === "dynamic"
                                                    ? `Next (${selectedTargets.length})`
                                                    : `Confirm Assign (${selectedTargets.length})`}
                                            </button>
                                        </div>
                                    )}
                                </div>
                                    )}

                                    {dynamicConfigOpen && (
                                        <div className="actions-dropdown">
                                            <div className="assign-panel">
                                                <div className="assign-panel-header">
                                                    <span>Make Dynamic</span>
                                                    <button
                                                        className="assign-panel-back"
                                                        onClick={() => {
                                                            setDynamicConfigOpen(false);
                                                            setAssignPanelOpen(true);
                                                            setActionsOpen(true);
                                                        }}
                                                    >
                                                        Back
                                                    </button>
                                                </div>
                                                <div className="assign-panel-list" style={{ padding: "10px 12px", display: "flex", flexDirection: "column", gap: "10px" }}>
                                                    <label style={{ fontSize: "12px", fontWeight: "600", color: "#1d1d1f" }}>
                                                        Assignment Title
                                                        <input
                                                            type="text"
                                                            value={dynamicTitle}
                                                            onChange={(e) => setDynamicTitle(e.target.value)}
                                                            placeholder="e.g. Emergency Training Sign-off"
                                                            style={{ width: "100%", marginTop: "4px", padding: "6px 8px", fontSize: "12px", border: "1px solid #ccc", borderRadius: "6px" }}
                                                        />
                                                    </label>
                                                    <label style={{ fontSize: "12px", fontWeight: "600", color: "#1d1d1f" }}>
                                                        Start Date
                                                        <input
                                                            type="date"
                                                            value={dynamicStartDate}
                                                            onChange={(e) => setDynamicStartDate(e.target.value)}
                                                            style={{ width: "100%", marginTop: "4px", padding: "6px 8px", fontSize: "12px", border: "1px solid #ccc", borderRadius: "6px" }}
                                                        />
                                                    </label>
                                                    <label style={{ fontSize: "12px", fontWeight: "600", color: "#1d1d1f" }}>
                                                    Frequency
                                                    <select
                                                        value={dynamicFrequency}
                                                        onChange={(e) => setDynamicFrequency(e.target.value)}
                                                        style={{ width: "100%", marginTop: "4px", padding: "6px 8px", fontSize: "12px", border: "1px solid #ccc", borderRadius: "6px" }}
                                                    >
                                                        <option value="ONCE">Once (single deadline)</option>
                                                        <option value="DAILY">Daily</option>
                                                        <option value="WEEKLY">Weekly</option>
                                                        <option value="MONTHLY">Monthly</option>
                                                    </select>
                                                </label>
                                                {dynamicFrequency === "ONCE" && (
                                                    <label style={{ fontSize: "12px", fontWeight: "600", color: "#1d1d1f" }}>
                                                        Deadline
                                                        <input
                                                            type="date"
                                                            value={dynamicDeadline}
                                                            onChange={(e) => setDynamicDeadline(e.target.value)}
                                                            style={{ width: "100%", marginTop: "4px", padding: "6px 8px", fontSize: "12px", border: "1px solid #ccc", borderRadius: "6px" }}
                                                        />
                                                    </label>
                                                )}
                                                <label style={{ fontSize: "12px", fontWeight: "600", color: "#1d1d1f" }}>
                                                    Completion Behavior
                                                    <select
                                                        value={dynamicCompletionBehavior}
                                                        onChange={(e) => setDynamicCompletionBehavior(e.target.value)}
                                                        style={{ width: "100%", marginTop: "4px", padding: "6px 8px", fontSize: "12px", border: "1px solid #ccc", borderRadius: "6px" }}
                                                    >
                                                        <option value="ENDS">Ends when completed</option>
                                                        <option value="REPEATS">Repeats each cycle</option>
                                                    </select>
                                                </label>
                                                    <label style={{ fontSize: "12px", fontWeight: "600", color: "#1d1d1f" }}>
                                                        Instructions
                                                        <textarea
                                                            value={dynamicInstructions}
                                                            onChange={(e) => setDynamicInstructions(e.target.value)}
                                                            placeholder="Instructions for the employee..."
                                                            rows={3}
                                                            style={{ width: "100%", marginTop: "4px", padding: "6px 8px", fontSize: "12px", border: "1px solid #ccc", borderRadius: "6px", resize: "vertical", fontFamily: "inherit" }}
                                                        />
                                                    </label>
                                                </div>
                                                <button
                                                    className="assign-confirm-button"
                                                    disabled={!dynamicTitle.trim() || !dynamicStartDate}
                                                    onClick={handleConfirmDynamic}
                                                >
                                                    Confirm Make Dynamic ({selectedTargets.length})
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>


                            )}

            </div>
        </nav>
    );
};

export default OuraSecondNav;
